// @flow

import React, {Fragment} from 'react';
import gql from 'graphql-tag';
import {FormattedMessage} from 'react-intl';
import PriceSummary from '@homeaway/react-price-summary';
import InstantBookIcon from '../InstantBookIcon/InstantBookIcon';
import {type IntlShape} from 'react-intl';
import {type ListingShape} from '../Hit/Hit';
import {type MultiUnitItemShape} from '../MultiUnitItem/MultiUnitItem';
import './Price.less';

export const fragments = {
    listing: gql`
        fragment PriceListing on Listing {
            priceSummary: priceSummary {
                edapEventJson
                formattedAmount
                pricePeriodDescription
            }
            priceSummarySecondary: priceSummary(
                summary: "displayPriceSecondary"
            ) {
                edapEventJson
                formattedAmount
                pricePeriodDescription
            }
        }
    `
};

export const listingHasPrice = (
    listing: ListingShape | MultiUnitItemShape
): boolean => {
    const {priceSummary} = listing || {};
    return !!priceSummary;
};

export type PriceSummaryShape = {
    edapEventJson: string,
    formattedAmount: string,
    pricePeriodDescription: string
};

export type PriceListingShape = {
    priceSummary: ?PriceSummaryShape,
    priceSummarySecondary: ?PriceSummaryShape
};

export type Props = {
    listing: ListingShape | MultiUnitItemShape
};

type WithInstantBookProps = {
    intl: IntlShape,
    instantBookable?: boolean
} & Props;

export function Price({listing}: Props) {
    if (listingHasPrice(listing)) {
        return <PriceSummary priceSummary={listing.priceSummary} />;
    }

    return (
        <span className="Price Price--noPrice" data-wdio="Price" data-price="0">
            <FormattedMessage
                id={'ratesNone'}
                description={'no price'}
                defaultMessage={'View details for price'}
            >
                {(txt) => <span className="Price__Fallback">{txt}</span>}
            </FormattedMessage>
        </span>
    );
}

export default function PriceWithInstantBook(props: WithInstantBookProps) {
    return (
        <Fragment>
            {props.instantBookable && <InstantBookIcon intl={props.intl} />}
            <Price {...props} />
        </Fragment>
    );
}
